import React from 'react';
import { Layout } from 'antd';
import { connect } from 'react-redux';
import { workOrderPrioritiesRestCrudThunks } from '../../thunks/work_order_priorities_thunks';
import FilterDrawer from './FilterDrawer';
import LifeCycleAnalyticsOverviewHeader from './LifeCycleAnalyticsOverviewHeader';
import LifeCycleAnalyticsOverviewDashboard from './LifeCycleAnalyticsOverviewDashboard';
import {
	fetchLifecycleMonthlyApprovalTime,
	fetchLifecycleMonthlyResponseTime,
	fetchLifecycleMonthlyResolutionTime,
	fetchLifecycleMonthlyFirstTimeFixRate,
	fetchLifecycleMonthlySpend,
	fetchLifecyclePrioritySummary,
	fetchLifecycleSupplierPerformance,
} from '../../thunks/lifecycle_analytics_thunks';
import { problemTypesHeirarchical } from '../../thunks/problem_types_thunks';
import { useLifeCycleAnalyticsOverview } from './useLifeCycleAnalyticsOverview';
import '../charts/chartTheme';
import './registerTopPerformerShape';
import './LifeCycleAnalyticsOverviewPage.less';

const { Content } = Layout;

const LifeCycleAnalyticsOverviewPage = (props) => {
	const { companyConfig, dashboard, filterDrawer } = useLifeCycleAnalyticsOverview(props);

	return (
		<Content className="lifeCycleAnalyticsOverviewPage">
			<LifeCycleAnalyticsOverviewHeader companyConfig={companyConfig} />
			<LifeCycleAnalyticsOverviewDashboard {...dashboard} />
			<FilterDrawer {...filterDrawer} />
		</Content>
	);
};

const mapStateToProps = (state) => ({
	userType: (state as any).session.userType,
	companyConfig: state.company_config,
	problemTypes: state.problem_types,
	workOrderPriorities: state.work_order_priorities,
});

const mapDispatchToProps = (dispatch) => ({ dispatch });

const mergeProps = (stateProps, dispatchProps, ownProps) => {
	const { userType } = stateProps;
	const { dispatch } = dispatchProps;
	return {
		...ownProps,
		...stateProps,
		fetchPrioritySummary: (params, filters = null, pagination = null, sorting = null) =>
			dispatch(fetchLifecyclePrioritySummary(userType)(params, filters, pagination, sorting)),
		fetchSupplierPerformance: (params, filters = null, pagination = null, sorting = null) =>
			dispatch(fetchLifecycleSupplierPerformance(userType)(params, filters, pagination, sorting)),
		fetchMonthlyApprovalTime: (params, filters = null, pagination = null, sorting = null) =>
			dispatch(fetchLifecycleMonthlyApprovalTime(userType)(params, filters, pagination, sorting)),
		fetchMonthlyResponseTime: (params, filters = null, pagination = null, sorting = null) =>
			dispatch(fetchLifecycleMonthlyResponseTime(userType)(params, filters, pagination, sorting)),
		fetchMonthlyResolutionTime: (params, filters = null, pagination = null, sorting = null) =>
			dispatch(fetchLifecycleMonthlyResolutionTime(userType)(params, filters, pagination, sorting)),
		fetchMonthlyFirstTimeFixRate: (params, filters = null, pagination = null, sorting = null) =>
			dispatch(
				fetchLifecycleMonthlyFirstTimeFixRate(userType)(params, filters, pagination, sorting)
			),
		fetchMonthlySpend: (params, filters = null, pagination = null, sorting = null) =>
			dispatch(fetchLifecycleMonthlySpend(userType)(params, filters, pagination, sorting)),
		fetchProblemTypes: (
			searchText,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				problemTypesHeirarchical(userType)(
					typeof searchText === 'string' && searchText ? { name: searchText } : {},
					targetCollectionName,
					pagination,
					sorting,
					filters,
					addToTargetCollection
				)
			),
		fetchWorkOrderPriorities: () => dispatch(workOrderPrioritiesRestCrudThunks(userType).read({})),
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(LifeCycleAnalyticsOverviewPage);
